import { render, staticRenderFns } from "./PersonTables.vue?vue&type=template&id=46d4ac9d&scoped=true&"
import script from "./PersonTables.vue?vue&type=script&lang=js&"
export * from "./PersonTables.vue?vue&type=script&lang=js&"
import style0 from "./PersonTables.vue?vue&type=style&index=0&id=46d4ac9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d4ac9d",
  null
  
)

export default component.exports